export const BRAND = {
  name: "fullshine.detailing",
  tagline: "Lavado y detailing premium a domicilio",
};

// Número de WhatsApp del cliente (España: 34 + 600299516)
export const WHATSAPP_NUMBER = "34600299516";

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const WHATSAPP_LINK = waLink(
  "Hola, quiero pedir cita para el detailing de mi coche."
);

export const NAV_LINKS = [
  { label: "Servicios", href: "#servicios" },
  { label: "Proceso", href: "#proceso" },
  { label: "Reservar", href: "#reservar" },
];

export const HERO_IMG =
  "https://images.unsplash.com/photo-1620584898989-d39f7f9ed1b7?q=85&w=1600&auto=format&fit=crop";

export const SERVICES = [
  {
    slug: "lavado-exterior",
    name: "Lavado Exterior",
    price: "desde 25€",
    desc: "Prelavado con espuma activa, lavado a dos cubetas y un acabado sin marcas. Tu pintura respira.",
    features: ["Espuma activa de prelavado", "Lavado a dos cubetas", "Llantas y neumáticos", "Secado con microfibra"],
    img: "https://images.unsplash.com/photo-1608506375591-b90e1f955e4b?q=85&w=1200&auto=format&fit=crop",
  },
  {
    slug: "lavado-completo",
    name: "Lavado Completo",
    price: "55€",
    desc: "Exterior + interior express: aspirado a fondo, plásticos y cristales como el primer día.",
    features: ["Todo lo del lavado exterior", "Aspirado completo", "Plásticos y consola", "Cristales sin marcas"],
    img: "https://images.unsplash.com/photo-1633014041037-f5446fb4ce99?q=85&w=1200&auto=format&fit=crop",
  },
  {
    slug: "detailing-interior",
    name: "Detailing Interior",
    price: "40€",
    desc: "Desengrase profundo de tapicería, cuero nutrido y un habitáculo que huele a nuevo.",
    features: ["Extracción de tapicería", "Cuero limpiado y nutrido", "Techo y alfomillas", "Desodorizado profesional"],
    img: "https://images.unsplash.com/photo-1606724553886-4899ab6f79e1?q=85&w=1200&auto=format&fit=crop",
  },
  {
    slug: "pulido-ceramico",
    name: "Pulido & Cerámico",
    price: "120€",
    desc: "Corte de brillo con orbital, descontaminación de pintura y sellado cerámico de larga duración.",
    features: ["Descontaminación de pintura", "Pulido de corrección de brillo", "Sellado cerámico", "Efecto espejo prolongado"],
    img: "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?q=85&w=1200&auto=format&fit=crop",
  },
];

export const SOCIALS = {
  instagram: "https://instagram.com/fullshine.detailingg",
  tiktok: "https://tiktok.com/@fullshine.detailingg",
};
